import Vue from "vue";
import VueRouter from "vue-router";
import home from "../views/home/home.vue";
import store from "../store";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "home",
        component: home,
    },
    {
        path: "/hazrat-masoomeh",
        component: () => import("../views/hazrat-masoomeh/hazrat-masoomeh.vue"),
        children: [
            {
                path: "ziarat-register",
                alias: "ziarat-register",
                name: "hazrat-masoomeh-ziarat-register",
                component: () =>
                    import(
                        "../views/hazrat-masoomeh/ziarat-register/ziarat-register.vue"
                        ),
                meta: {title: "زیارت نیابتی حضرت معصومه"},
            },
            {
                path: "/features",
                name: "hazrat-masoomeh-features",
                component: () =>
                    import("../views/hazrat-masoomeh/features/features.vue"),
            },
        ],
    },
    {
        path: "/imam-hussain",
        component: () => import("../views/imam-hussain/imam-hussain.vue"),
        children: [
            {
                path: "ziarat-register",
                name: "imam-hussain-ziarat-register",
                component: () =>
                    import("../views/imam-hussain/ziarat-register/ziarat-register.vue"),
                meta: {title: "زیارت نیابتی امام حسین"},
            },
            {
                path: "ziarat-register-without-auth",
                name: "imam-hussain-ziarat-register",
                component: () =>
                    import("../views/imam-hussain/ziarat-register/ziarat-register.vue"),
                meta: {
                    title: "زیارت نیابتی امام حسین",
                    noNeedTokenAsQueryString: true,
                },
            },
            {
                path: "/features",
                name: "imam-hussain-features",
                component: () => import("../views/imam-hussain/features/features.vue"),
            },
        ],
    },
    {
        path: "/imam-reza/features",
        name: "imam-reza-features",
        component: () => import("../views/imam-reza/features/features.vue"),
    },
    {
        path: "/inquiry/:type",
        name: "inquiry",
        component: () => import("../views/inquiry/inquiry.vue"),
    },
    {
        path: "/inquiry/inquiry-details/:type/:id",
        name: "inquiry-details",
        component: () => import("../views/inquiry/inquiry-details/inquiry-details.vue"),
    },
    {
        path: "/forbidden",
        name: "forbidden",
        component: () => import("../views/forbidden/forbidden.vue"),
        meta: {
            noNeedTokenAsQueryString: true,
        },
    },
    // { path: "*", redirect: "/" },
    {path: "*", redirect: "/forbidden"},
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, from, next) => {
    if (to.meta.noNeedTokenAsQueryString) {
        next();
        return;
    }

    // set for first time(once)
    if (!store.state.queryParams) {
        let queryParams = null;
        try {
            if (process.env.NODE_ENV === "development") {
                queryParams = {
                    token: decodeURIComponent(
                        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRlIjoxNjkxOTA4Mzc2NTk3LCJpZCI6IjE4MWRkNDQ1M2RiOTZkNTU1NzU2ZmRlZGUwY2FlNWVmIiwiaWF0IjoxNjkxOTA4Mzc2LCJleHAiOjE2OTE5MDg4NzZ9.nH086r8N7LnaDOzk8y2SNW6_Utjg3u1EVuphitQS7AA"
                    ),
                };
            }
            if (to.query.token) {
                queryParams = {token: decodeURIComponent(to.query.token)};
            }
        } catch (error) {
            console.error(error)
        }
        console.log('queryParams', queryParams)
        if (queryParams)
            store.commit("setQueryParams", {
                token: to.query.token,
                ...queryParams,
            });
    }

    const query = store.state.queryParams;
    console.log('store.state.queryParams', query)
    if (
        !to.meta.noNeedTokenAsQueryString &&
        query &&
        Object.keys(query).length > 0
    ) {
        next();
    } else {
        next("/forbidden");
    }
});

router.afterEach((to, from) => {
    if (!to.meta.noNeedTokenAsQueryString) {
        const newQuery = {...to.query};

        if (store.state.queryParams?.token) {
            newQuery.token = encodeURIComponent(store.state.queryParams?.token);
        }

        router
            .replace({
                replace: true,
                query: newQuery,
            })
            .catch(() => {
            });
    }

    if (to.meta.title) {
        Vue.nextTick(() => (document.title = to.meta.title));
    }

    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
});

export default router;
